import React, { useContext } from 'react'
import Skeleton from 'react-loading-skeleton'
import UploadAvatar from './UploadAvatar'
import { MeContext } from '../contexts/me'

interface UserCardProps {
  layoutProfile?: boolean
  mobileMenu?: boolean
  className?: string
}

const UserCard = ({
  layoutProfile = false,
  mobileMenu = false,
  className = ''
}: UserCardProps) => {
  const { me } = useContext(MeContext)

  const profileImageURL = me?.profile?.images[0]?.url
  const initialNameLetter = me?.profile?.name[0]

  return (
    <div
      className={`${
        layoutProfile
          ? 'flex items-center py-[30px] w-full'
          : 'flex justify-center gap-4 items-center'
      } ${className}`}
    >
      {/* avatar */}
      <div
        className={`flex relative shrink-0 items-center bg-green-930 rounded-full ${
          layoutProfile ? 'w-[150px] h-[150px]' : 'h-10 w-10'
        }`}
      >
        {!profileImageURL ? (
          <Skeleton
            className='mb-1'
            height={layoutProfile ? 150 : 41}
            width={layoutProfile ? 150 : 41}
            circle
          />
        ) : (
          <div className='relative block w-full'>
            {profileImageURL ? (
              <img
                className={`rounded-full bg-center object-cover bg-cover ${
                  layoutProfile ? 'w-[150px] h-[150px]' : 'h-10 w-10'
                }`}
                src={profileImageURL}
                alt='Avatar'
              />
            ) : (
              // INITIALS (default image)
              <div className='flex text-6xl w-full justify-center items-center text-white'>
                {initialNameLetter}
              </div>
            )}
          </div>
        )}
        {layoutProfile && (
          <UploadAvatar image={profileImageURL || initialNameLetter} />
        )}
      </div>
      {/* user name */}
      <span
        className={
          layoutProfile
            ? 'font-bold text-lg ml-6 text-purple-900 capitalize'
            : `font-bold text-xs capitalize ${
                mobileMenu ? 'block' : 'hidden md:block'
              }`
        }
      >
        {me?.profile?.name?.toLowerCase()} {me?.profile?.surname?.toLowerCase()}
      </span>
    </div>
  )
}

export default UserCard
